/**
 * Data Format Handler Utility
 * Normalizes API response data to always return an array
 * Handles both array format and object format (e.g., { products: [...] })
 * 
 * @param {any} data - Raw API response data
 * @param {string} arrayKey - Key name for object format (e.g., 'products', 'events')
 * @param {string} dataType - Type of data for logging (e.g., 'products', 'events')
 * @returns {Array} - Normalized array
 */
export function normalizeArrayData(data, arrayKey, dataType = 'data') {
  if (Array.isArray(data)) {
    console.log(`📊 ${dataType} array format detected`);
    return data;
  } else if (data && data[arrayKey] && Array.isArray(data[arrayKey])) {
    console.log(`📊 ${dataType} object format detected`);
    return data[arrayKey];
  } else {
    console.log(`⚠️ Unknown ${dataType} format, treating as empty`);
    return [];
  }
}

